import { appointmentHasLinkedEncounter } from "../appointments/appointmentEncounter";
import { snapBookingStart } from "./snapBookingStart";

export function canMoveOwnAppointment(event, practitionerRef, scheduleId, now = Date.now()) {
  const source = event?.extendedProps?.source;
  return event?.extendedProps?.kind === "appointment" && source?.status === "booked" &&
    !appointmentHasLinkedEncounter(source) &&
    source.practitionerRefs?.length === 1 && source.practitionerRefs[0] === practitionerRef &&
    source.scheduleIds?.length === 1 && source.scheduleIds[0] === scheduleId &&
    Date.parse(source.startsAt) > now && Date.parse(source.endsAt) > Date.parse(source.startsAt);
}

export function getMyScheduleMove({ event, requestedStart, practitionerRef, scheduleId, categories, availability, blocks, now = Date.now() }) {
  if (!canMoveOwnAppointment(event, practitionerRef, scheduleId, now)) return null;
  const appointment = event.extendedProps.source;
  const duration = Date.parse(appointment.endsAt) - Date.parse(appointment.startsAt);
  const category = categories.find(item => item.serviceCategoryId === appointment.serviceCategoryId);
  const start = snapBookingStart({ requestedStart: +new Date(requestedStart), duration,
    increment: category?.bookingIncrementMinutes * 60000, windows: availability,
    scheduleIds: [scheduleId], serviceCategoryId: appointment.serviceCategoryId, now });
  if (start === null || blocks.some(block => block.active !== false && start < Date.parse(block.endsAt) && start + duration > Date.parse(block.startsAt))) return null;
  return { appointment, practitionerRef, fromPractitionerRef: practitionerRef,
    startsAt: new Date(start).toISOString(), endsAt: new Date(start + duration).toISOString() };
}
